/* Open/close animation for .details-accordion (shared accordion-item snippet), driven by
   a CSS grid-template-rows transition (0fr <-> 1fr) instead of a JS-measured pixel height:
   the browser interpolates against the content's own natural size every frame, so there's
   no offsetHeight snapshot that can go stale if content reflows mid-animation (web fonts,
   images, adjacent accordions animating at the same time). */
(() => {
  // This file is included by every section that uses the shared accordion-item snippet
  // (main-product-hero.liquid, product-faq.liquid, ...), so it can legitimately load more
  // than once on the same page. Without this guard, a second execution attaches a second
  // click listener, and on open the redundant listener sees details.open already set to
  // true by the first one and immediately treats the click as a close.
  if (window.__detailsAccordionInit) return;
  window.__detailsAccordionInit = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.details-accordion__trigger');
    if (!summary) return;
    const details = summary.closest('.details-accordion');
    const panel = details && details.querySelector('.details-accordion__panel');
    if (!details || !panel) return;
    event.preventDefault();
    if (details.dataset.animating) return;

    if (details.open) {
      if (reducedMotion.matches) {
        details.open = false;
        return;
      }
      details.dataset.animating = 'true';
      const onEnd = (e) => {
        if (e.target !== panel || e.propertyName !== 'grid-template-rows') return;
        panel.removeEventListener('transitionend', onEnd);
        details.open = false;
        delete details.dataset.animating;
      };
      panel.addEventListener('transitionend', onEnd);
      panel.classList.remove('is-open');
    } else {
      details.open = true;
      if (reducedMotion.matches) {
        panel.classList.add('is-open');
        return;
      }
      // Force a layout flush between opening <details> and adding the class, so the
      // transition actually starts from 0fr instead of jumping straight to 1fr.
      panel.getBoundingClientRect();
      panel.classList.add('is-open');
    }
  });
})();
